export const sortByProperty = <T>({
    data,
    key,
    sortDirection = 'asc',
    valueSelector,
}: {
    data: T[];
    key?: keyof T;
    sortDirection?: 'asc' | 'desc';
    valueSelector?: (item: T) => unknown;
}): T[] =>
    [...data].sort((a, b) => {
        if (!key && !valueSelector) {
            throw new Error('key or valueSelector need be present!');
        }

        let valueA = valueSelector ? valueSelector(a) : key && a[key];
        let valueB = valueSelector ? valueSelector(b) : key && b[key];

        if (sortDirection === 'desc') {
            [valueA, valueB] = [valueB, valueA]; // Swap values
        }

        if (typeof valueA === 'string' && typeof valueB === 'string') {
            const stringA = valueA.toUpperCase();
            const stringB = valueB.toUpperCase();
            return stringA < stringB ? -1 : stringA > stringB ? 1 : 0;
        }

        if (typeof valueA === 'number' && typeof valueB === 'number') {
            return valueA - valueB;
        }

        // no sort
        return 0;
    });
